import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { ImportSetResults } from './types';
import { ComplexValue } from 'app/types-shared';

export const mapList = (listWire: ImportSetResults[]): ComplexValue<number>[] => {

  if ((listWire?.length ?? 0) === 0) {
    return [];
  }

  return listWire.map(item => ({
    value: item?.v,
    description: item?.d,
    disabled: parseAsDateUTC(item?.disabled)
  }));
};
